import {ThreeBuiltInEquipment} from '../ThreeBuiltInEquipment';

export class ThreeBuiltinWasherEquipment extends ThreeBuiltInEquipment {


}